import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Website in progress... [<a href="https://github.com/Quaint-Studios/Reia">GitHub repository</a>]</p>
      </header>
    </div>
  );
}

export default App;
